import { Bot } from 'lucide-react'
import type { Incident } from '../../incidents/types/incident.types'

interface DraftReviewStripProps {
  drafts: Incident[]
  onKeep: (id: number) => void
  isUpdating: boolean
}

export function DraftReviewStrip({ drafts, onKeep, isUpdating }: DraftReviewStripProps): JSX.Element | null {
  if (drafts.length === 0) return null

  return (
    <div className="flex flex-col gap-2">
      <h2 className="text-sm font-semibold text-gray-700">Draft Tasks — Pending Review</h2>
      {drafts.map((draft) => {
        const pct = draft.confidence != null ? Math.round(draft.confidence * 100) : null
        return (
          <div
            key={draft.id}
            className="flex items-center gap-3 rounded-lg border border-amber-200 bg-amber-50 px-4 py-2.5"
          >
            <Bot className="h-4 w-4 shrink-0 text-amber-600" aria-hidden="true" />
            <div className="min-w-0 flex-1">
              <p className="truncate text-sm font-medium text-amber-900">{draft.title}</p>
              {(draft.intent || pct != null) && (
                <p className="mt-0.5 text-xs text-amber-700">
                  AI suggestion
                  {draft.intent ? ` · ${draft.intent}` : ''}
                  {pct != null ? ` · ${pct}% confidence` : ''}
                </p>
              )}
            </div>
            <button
              type="button"
              disabled={isUpdating}
              onClick={() => onKeep(draft.id)}
              className="shrink-0 rounded-md bg-amber-600 px-3 py-1 text-xs font-semibold text-white hover:bg-amber-700 disabled:opacity-50"
            >
              Keep
            </button>
          </div>
        )
      })}
    </div>
  )
}
